import { formatRouteForAAB } from './format-route-for-aab.js';
import { wildcardUrlMatcher } from './wildcard-url-matcher.js';

const applyBloomreachAppointmentUrlsConfiguration = ({ pathname , appointmentRoute , appointmentMenuItems , content  })=>{
    var ref;
    if (!content || !content.length) {
        return appointmentMenuItems;
    }
    var ref1;
    const typeId = (ref1 = (ref = content.find((item)=>wildcardUrlMatcher(item.url, pathname)
    )) === null || ref === void 0 ? void 0 : ref.typeId) !== null && ref1 !== void 0 ? ref1 : '';
    if (!typeId) {
        return appointmentMenuItems;
    }
    return formatRouteForAAB({
        appointmentMenuItems,
        appointmentRoute,
        searchParams: new URLSearchParams({
            typeId
        }).toString()
    });
};

export { applyBloomreachAppointmentUrlsConfiguration };
//# sourceMappingURL=apply-bloomreach-appointment-urls-configuration.js.map
